import SearchTopPart from "@/custolink-views/asset_frontend/ui/building_blocks/SearchTopPart";
import { APP_NAME } from "@/constants/app.constant";
import BottomNavigation from "@/custolink-views/asset_frontend/ui/building_blocks/BottomNavigation";
import Drawer from "@/components/ui/Drawer/Drawer";
import Alert from "@/components/ui/Alert/Alert";
import { Input } from "@/components/ui/Input";
import { BiQrScan, BiSearch } from "react-icons/bi";
import { Button } from "@/components/ui/Button";
import { HiFire } from "react-icons/hi";
import { useEffect, useMemo, useState } from "react";
import Table from "@/components/ui/Table";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  PublicAssetFrontendApi,
  PublicAssetFrontendApi$AssetComponentDto,
  PublicAssetFrontendApi$AssetComponentDtoKey,
  PublicAssetFrontendApi$AssetComponents,
} from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import useUiContext from "@/custolink-hooks/useUiContext";
import { Link, useNavigate } from "react-router-dom";
import { PiInfo } from "react-icons/pi";
import MiddleSection from "@/custolink-views/asset_frontend/ui/components/MiddleSection";
import AssetHeaderComponents from "@/custolink-views/asset_frontend/ui/components/AssetHeaderComponents";
import {
  CustomAssetViewVisitedEntry,
  DefaultAssetViewVisitedEntry,
  getVisitedAssets,
  SnoPatternMatchVisitedEntry,
} from "@/custolink-views/asset_frontend/visited_assets";
import FirstTimeDialog from "@/custolink-views/asset_frontend/ui/shared/FirstTimeDialog";
import AccountDrawer from "@/custolink-views/asset_frontend/account/AccountDrawer";
import BottomSection from "@/custolink-views/asset_frontend/ui/components/BottomSection";
import PageHeader from "@/custolink-views/asset_frontend/ui/layout/PageHeader";
import PageContent from "@/custolink-views/asset_frontend/ui/layout/PageContent";
import { FrontendAssetScanApi } from "@/custolink-transpiled_by_server/bc.assets.api_methods";
import VoiceCallAppPageComponent from "@/custolink-views/asset_frontend/asset_view/asset_components/VoiceCallAppPageComponent";
import useAssetViewTranslator from "@/custolink-views/asset_frontend/useAssetViewTranslator";
import { useTranslation } from "react-i18next";
import Scan from "@/custolink-views/asset_frontend/scan/Scan";

const { Tr, Td, TBody } = Table;

export default function AssetFrontendHome() {
  const uic = useUiContext();
  const [accountDrawerOpen, setAccountDrawerOpen] = useState(false);
  const [scanDrawerOpen, setScanDrawerOpen] = useState(false);
  const t = useAssetViewTranslator();
  const q = useQuery({
    queryFn: () => PublicAssetFrontendApi.getComponents(uic._orgId),
    queryKey: ["PublicAssetFrontendApi.getComponents", uic._orgId],
  });
  const navigate = useNavigate();

  const [showFirstTimeDialog, setShowFirstTimeDialog] = useState(
    localStorage.getItem("firsttime_dialog_shown") !== "true",
  );
  const [showSelectAssetDrawer, setShowSelectAssetDrawer] = useState(false);
  const [selectedComponent, setSelectedComponent] =
    useState<PublicAssetFrontendApi$AssetComponentDto | null>(null);

  const components: PublicAssetFrontendApi$AssetComponents | null =
    useMemo(() => {
      if (q.data?.components == null) {
        return null;
      }
      return {
        bottomSection: t.translateNames(q.data.components.bottomSection),
        topSection: t.translateNames(q.data.components.topSection),
        middleSection: t.translateNames(q.data.components.middleSection),
      };
    }, [q.data?.components, t]);

  return (
    <>
      <PageHeader>
        <SearchTopPart
          onClickScan={() => {
            setScanDrawerOpen(true);
          }}
        />

        <div className={"flex bg-white rounded-2xl"}>
          <div className={"flex justify-center items-center w-full"}>
            <img
              className={"p-6"}
              //src={"/img/logo/akea.jpg"}
              src={uic.organisationContext.lookAndFeel.logoUrl}
              //src={"/img/logo/FINAL FILE CUSTOLINK LOGO LEFT 1.png"}
              //src={`${LOGO_SRC_PATH}logo-${mode}-${type}.png`}
              alt={`${APP_NAME} logo`}
            />
          </div>
          <div className={"relative"}>
            <Button
              className={
                "absolute right-2 top-2 bg-background-color-asset-frontend"
              }
              variant={"solid"}
              icon={<PiInfo />}
              title={"What is this?"}
              shape={"round"}
              size={"xs"}
              style={{}}
              onClick={() => setShowFirstTimeDialog(true)}
            ></Button>
          </div>
        </div>

        <AssetHeaderComponents
          components={components?.topSection ?? []}
          onClickComponent={() => {
            setShowSelectAssetDrawer(true);
          }}
        />
      </PageHeader>

      <PageContent>
        <MiddleSection
          components={components?.middleSection ?? []}
          selectComponentToShow={() => {
            setShowSelectAssetDrawer(true);
          }}
        />

        <BottomSection
          components={components?.bottomSection ?? []}
          selectComponent={(c) => {
            if (
              c.key == PublicAssetFrontendApi$AssetComponentDtoKey.VoiceCall
            ) {
              setSelectedComponent(c);
            } else {
              setShowSelectAssetDrawer(true);
            }
          }}
        />

        <Recent />

        <div className={"pb-24"}>&nbsp;</div>
      </PageContent>

      <BottomNavigation
        onClickHome={() => {
          setShowSelectAssetDrawer(false);
          setSelectedComponent(null);
          setAccountDrawerOpen(false);
          setScanDrawerOpen(false);
          navigate("/");
        }}
        onClickAccount={() => {
          setShowSelectAssetDrawer(false);
          setSelectedComponent(null);
          setAccountDrawerOpen(true);
          setScanDrawerOpen(false);
        }}
        onClickScan={() => {
          setShowSelectAssetDrawer(false);
          setSelectedComponent(null);
          setAccountDrawerOpen(false);
          setScanDrawerOpen(true);
        }}
      />

      <Drawer
        title={selectedComponent?.name ?? ""}
        isOpen={selectedComponent != null}
        placement="right"
        width={"100%"}
        bodyClass={""}
        onClose={() => {
          setSelectedComponent(null);
        }}
        onRequestClose={() => {
          setSelectedComponent(null);
        }}
      >
        {selectedComponent != null && (
          <>
            {selectedComponent.key ==
              PublicAssetFrontendApi$AssetComponentDtoKey.VoiceCall && (
              <>
                <VoiceCallAppPageComponent component={selectedComponent} />
              </>
            )}
          </>
        )}
      </Drawer>

      <AccountDrawer
        open={accountDrawerOpen}
        close={() => {
          setShowSelectAssetDrawer(false);
          setAccountDrawerOpen(false);
        }}
        useThisFeatureAlert={false}
      />

      <Scan open={scanDrawerOpen} close={() => setScanDrawerOpen(false)} />

      <SelectAssetDrawer
        open={showSelectAssetDrawer}
        close={() => setShowSelectAssetDrawer(false)}
        onScan={() => {
          setShowSelectAssetDrawer(false);
          setScanDrawerOpen(true);
        }}
      />

      <FirstTimeDialog
        show={showFirstTimeDialog}
        close={() => {
          localStorage.setItem("firsttime_dialog_shown", "true");
          setShowFirstTimeDialog(false);
        }}
      />
    </>
  );
}

const SelectAssetDrawer = (p: {
  open: boolean;
  close: () => void;
  onScan: () => void;
}) => {
  const uic = useUiContext();
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const q = useMutation({
    mutationFn: (query: string) =>
      FrontendAssetScanApi.assetLookup(uic._orgId, query),
    mutationKey: ["SelectAssetDrawer_serialNumberLookup"],
  });
  const navigate = useNavigate();
  const lf = uic.organisationContext.lookAndFeel;

  useEffect(() => {
    if (q.data != null && q.data?.defaultViewResult != null) {
      navigate("/asset/" + q.data.defaultViewResult.serialnumber);
    } else if (q.data != null && q.data?.customViewResult != null) {
      navigate(
        "/view/" +
          q.data.customViewResult.urlSlug +
          "/" +
          q.data.customViewResult.attrValue,
      );
    }
  }, [q.data]);

  return (
    <Drawer
      title={t("assetSelection.title")}
      isOpen={p.open}
      placement="right"
      width={"100%"}
      onClose={() => {
        p.close();
      }}
      onRequestClose={() => {
        p.close();
      }}
    >
      <div className={"space-y-4"}>
        <div className="text-gray-500 dark:text-gray-400">
          <Alert
            type={"info"}
            showIcon={true}
            customIcon={<HiFire />}
            closable={true}
          >
            {t("assetSelection.requiresAsset")}
          </Alert>
        </div>

        <Input
          placeholder={
            lf.i18nAssetFrontendSnoSearchbarPlaceholder != null
              ? t(lf.i18nAssetFrontendSnoSearchbarPlaceholder)
              : lf.assetFrontendSnoSearchbarPlaceholder
          }
          value={query}
          onChange={(ev) => setQuery(ev.target.value)}
        />
        <Button
          variant={"solid"}
          className={"w-full"}
          icon={<BiSearch />}
          loading={q.isPending}
          onClick={() => {
            q.mutate(query);
          }}
        >
          {t("assetSelection.search")}
        </Button>

        {/*
          q.data?.productname != null && q.data?.serialnumber != null && (
          <>
            <div className="flex flex-col items-center justify-center m-4 space-y-2">
              <h4 className="">We found an asset with the serial number:</h4>
              <div className="mr-2 rtl:ml-2">
                <Tag className="text-white bg-indigo-600 border-0">
                  {q.data?.productname}
                </Tag>
              </div>
              <a
                href={"/asset/" + q.data?.serialnumber}
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline flex items-center gap-2"
              >
                Go to the asset <HiExternalLink />
              </a>
            </div>
          </>
        )
        */}

        <div className={"flex justify-center"}>{t("assetSelection.or")}</div>

        <div className={"flex justify-center w-full"}>
          <Button
            className={"w-full"}
            variant={"solid"}
            icon={<BiQrScan />}
            onClick={() => p.onScan()}
          >
            {t("assetSelection.scan")}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

const Recent = () => {
  const uic = useUiContext();
  const { t } = useTranslation();
  const visited = useMemo(() => {
    return getVisitedAssets(uic._orgId);
  }, []);
  if (visited.length == 0) {
    return null;
  }
  return (
    <div className="text-white space-y-2">
      <h5>{t("home.assets.recentlyVisited")}</h5>
      <div>
        <Table compact>
          <TBody>
            {visited.map((visitedEntry) => {
              if (
                (visitedEntry as DefaultAssetViewVisitedEntry).productName !=
                undefined
              ) {
                const visited = visitedEntry as DefaultAssetViewVisitedEntry;
                return (
                  <Tr key={visited.serialName}>
                    <Td className={"text-primary"}>
                      <Link
                        to={"/asset/" + encodeURIComponent(visited.serialName)}
                      >
                        {visited.productName}
                      </Link>
                    </Td>
                    <Td className={"text-primary"}>
                      <Link
                        to={"/asset/" + encodeURIComponent(visited.serialName)}
                      >
                        {visited.serialName}
                      </Link>
                    </Td>
                  </Tr>
                );
              } else if (
                (visitedEntry as SnoPatternMatchVisitedEntry).snoSerialName !=
                undefined
              ) {
                const visited = visitedEntry as SnoPatternMatchVisitedEntry;
                return (
                  <Tr key={visited.snoSerialName}>
                    <Td className={"text-primary"}>
                      <Link
                        to={
                          "/asset/" + encodeURIComponent(visited.snoSerialName)
                        }
                      >
                        {visited.productName}
                      </Link>
                    </Td>
                    <Td className={"text-primary"}>
                      <Link
                        to={
                          "/asset/" + encodeURIComponent(visited.snoSerialName)
                        }
                      >
                        {visited.snoSerialName}
                      </Link>
                    </Td>
                  </Tr>
                );
              } else if (
                (visitedEntry as CustomAssetViewVisitedEntry).slug != undefined
              ) {
                const visited = visitedEntry as CustomAssetViewVisitedEntry;
                return (
                  <Tr key={visited.slug + "_" + visited.value}>
                    <Td className={"text-primary"}>
                      <Link
                        to={
                          "/view/" +
                          visited.slug +
                          "/" +
                          encodeURIComponent(visited.value)
                        }
                      >
                        {visited.title}
                      </Link>
                    </Td>
                    <Td className={"text-primary"}>
                      <Link
                        to={
                          "/view/" +
                          visited.slug +
                          "/" +
                          encodeURIComponent(visited.value)
                        }
                      >
                        {visited.value}
                      </Link>
                    </Td>
                  </Tr>
                );
              }
            })}
          </TBody>
        </Table>
      </div>
    </div>
  );
};
